import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderTotal' })
export class OrderTotalPipe implements PipeTransform{
    transform(items): number { 
        var total = 0;
        items.forEach(element => {
            total += parseInt(element.price);
        });    
        return total;
    }

}